import React from 'react';
import './Longerscrew.css';

const Longerscrew = () => {
  return (
    <div className="Longers-container">
      <h2 className="Longers-heading">FEATURES</h2>

      <div className="Longers-card"data-aos="fade-down" > 
        

        <ul className="Longers-list">
          <li><strong>Longer Screw Lift-time  –</strong> Match with double alloy screw barrel,more wear-resisting,corrosion.</li>
          <li><strong>Large Shot Weight –</strong>Specially designed larger-diameter screw, not only the injection volume is large, but also reduces the charging time.</li>
          <li><strong>Shorter Cycle Time –</strong> Increase the hydraulic system, shorten the production cycle, improve production efficiency.</li>
          <li><strong>Saving More Energy –</strong>  Match with efficient imported variable pump, lower the production cost.</li>
          <li><strong>More Stable –</strong>Use new rigid frame, shock absorption is more better, and resulting more stable production.</li>
        </ul>
      </div>
    </div>
  );
};

export default Longerscrew;
